import { z } from 'zod'

/**
 * Schéma pour valider les données d'une tâche de diagnostic
 */
export const DiagnosticTaskSchema = z.object({
  taskId: z.number(),
  taskTitle: z.string(),
  taskOrder: z.number(),
  diagScorePercentRounded: z.number().nullable(),
  diagEvalRangeName: z.string().nullable(),
  diagEndScorePercentRounded: z.number().nullable(),
  diagEndEvalRangeName: z.string().nullable()
})

/**
 * Schéma pour valider les données d'un résultat d'étudiant en diagnostic
 */
export const DiagnosticStudentResultSchema = z.object({
  identifier: z.string(),
  firstname: z.string(),
  lastname: z.string(),
  periodId: z.number(),
  schoolYearName: z.string(),
  classroomId: z.number(),
  groupId: z.number().nullable(),
  groupName: z.string().nullable(),
  teacherId: z.number().nullable(),
  teacherFirstname: z.string().nullable(),
  teacherLastname: z.string().nullable(),
  tasks: z.array(DiagnosticTaskSchema)
})

/**
 * Schéma pour valider un tableau de résultats de diagnostic
 */
export const ClassroomDiagnosticResultsArraySchema = z.array(DiagnosticStudentResultSchema)

export type DiagnosticTaskEntity = z.infer<typeof DiagnosticTaskSchema>
export type DiagnosticStudentResultEntity = z.infer<typeof DiagnosticStudentResultSchema>
export type ClassroomDiagnosticResultsArrayEntity = z.infer<
  typeof ClassroomDiagnosticResultsArraySchema
>
